import React from "react";
import Header from '../components/header';
import Repos from '../components/repos';
import Ednav from '../components/education-nav';

export default () => <div>
    <Header/>
    <Ednav/>
    <Repos/>
</div>
